import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AppLocalStorage } from '../../../app-storage-manager/local-storage';
import { Store } from '@ngrx/store';
import { AppState } from 'app/reducers';
import { logout } from '../_state/auth.actions';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private toastr: ToastrService, private storeManager: AppLocalStorage, private store: Store<AppState>) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.storeManager.getAccessToken();
        const request = token
            ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) })
            : req;

        // A 401 on the auth endpoints means bad credentials / OTP, not an expired
        // session — let the login/MFA effects surface that message instead.
        const isAuthEndpoint = /\/asa\/users\/(login|verify-otp|resend-otp)\b/.test(request.url);

        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                // Only treat a 401 as an expired session when the user actually had one
                // (a token was attached) and it isn't the login flow itself.
                const isSessionExpiry =
                    (error.status === 401 || error.error?.errors === 'Token is not valid') &&
                    !!token && !isAuthEndpoint;
                if (isSessionExpiry) {
                    this.toastr.info('Login to continue', 'Your session has expired and you have been logged out');
                    this.store.dispatch(logout());
                }
                return throwError(error);
            })
        );
    }
}